import { render, staticRenderFns } from "./parkingDetail.vue?vue&type=template&id=4648802c&scoped=true"
import script from "./parkingDetail.vue?vue&type=script&lang=js"
export * from "./parkingDetail.vue?vue&type=script&lang=js"
import style0 from "./parkingDetail.vue?vue&type=style&index=0&id=4648802c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4648802c",
  null
  
)

export default component.exports